import * as types from './types';

const setDynamicItems = (unitNumber, subunitNumber, items) => {
  return {
    type: types.SET_DYNAMIC_ITEMS,
    payload: {
      [unitNumber]: {
        [subunitNumber]: items,
      },
    },
  };
};

const removeDynamicItems = (unitNumber, subunitNumber) => {
  return {
    type: types.REMOVE_DYNAMIC_ITEMS,
    payload: {
      [unitNumber]: {
        [subunitNumber]: [],
      },
    },
  };
};

const setQuestionProps = (props) => {
  return {
    type: types.SET_QUESTION_PROPS,
    payload: props,
  };
};

export { setDynamicItems, removeDynamicItems, setQuestionProps };
